// AI chat history kept per document while it is open. Session storage lets it
// survive reloads and is dropped by the browser when the tab is closed.

const PREFIX = 'aiChat:'

// Chats already shown in each editor, whose pending changes still exist in it
const loaded = new WeakMap()

const loadedIn = (editor) => {
  if (!loaded.has(editor)) {
    loaded.set(editor, new Set())
  }
  return loaded.get(editor)
}

const read = (key) => {
  try {
    return JSON.parse(sessionStorage.getItem(PREFIX + key)) || []
  } catch (error) {
    return []
  }
}

export const loadAiChat = (editor, key) => {
  if (!key) {
    return []
  }
  const messages = read(key).map(message => ({ ...message, activity: null }))
  // Without an editor (read-only) there are no pending changes to show
  if (editor && loadedIn(editor).has(key)) {
    return messages
  }
  if (editor) {
    loadedIn(editor).add(key)
  }
  // Pending changes made in an earlier editor are gone
  return messages.map(({ changeIds, ...message }) => message)
}

export const saveAiChat = (key, messages) => {
  if (!key) {
    return
  }
  try {
    if (messages.length) {
      sessionStorage.setItem(PREFIX + key, JSON.stringify(messages))
    } else {
      sessionStorage.removeItem(PREFIX + key)
    }
  } catch (error) {
    // Storage full or unavailable: the chat just isn't kept
  }
}

export const clearAiChat = (key) => saveAiChat(key, [])

export const moveAiChat = (from, to) => {
  if (from === to) {
    return
  }
  const messages = read(from)
  clearAiChat(from)
  if (messages.length) {
    saveAiChat(to, messages)
  }
}
